export default __webpack_public_path__ + "static/media/seller3.7438d8be.jpg";